/*! modernizr 3.6.0 (Custom Build) | MIT *
 * https://modernizr.com/download/?-customevent-promises-setclasses !*/
!(function (n, e, o) {
	function s(n, e) {
		return typeof n === e;
	}
	function i() {
		var n, e, o, i, t, f, l;
		for (var c in r)
			if (r.hasOwnProperty(c)) {
				if (
					((n = []),
					(e = r[c]),
					e.name &&
						(n.push(e.name.toLowerCase()), e.options && e.options.aliases && e.options.aliases.length))
				)
					for (o = 0; o < e.options.aliases.length; o++) n.push(e.options.aliases[o].toLowerCase());
				for (i = s(e.fn, 'function') ? e.fn() : e.fn, t = 0; t < n.length; t++)
					(f = n[t]),
						(l = f.split('.')),
						1 === l.length
							? (Modernizr[l[0]] = i)
							: (!Modernizr[l[0]] ||
									Modernizr[l[0]] instanceof Boolean ||
									(Modernizr[l[0]] = new Boolean(Modernizr[l[0]])),
							  (Modernizr[l[0]][l[1]] = i)),
						a.push((i ? '' : 'no-') + l.join('-'));
			}
	}
	function t(n) {
		var e = l.className,
			o = Modernizr._config.classPrefix || '';
		if ((c && (e = e.baseVal), Modernizr._config.enableJSClass)) {
			var s = new RegExp('(^|\\s)' + o + 'no-js(\\s|$)');
			e = e.replace(s, '$1' + o + 'js$2');
		}
		Modernizr._config.enableClasses &&
			((e += ' ' + o + n.join(' ' + o)), c ? (l.className.baseVal = e) : (l.className = e));
	}
	var a = [],
		r = [],
		f = {
			_version: '3.6.0',
			_config: {classPrefix: '', enableClasses: !0, enableJSClass: !0, usePrefixes: !0},
			_q: [],
			on: function (n, e) {
				var o = this;
				setTimeout(function () {
					e(o[n]);
				}, 0);
			},
			addTest: function (n, e, o) {
				r.push({name: n, fn: e, options: o});
			},
			addAsyncTest: function (n) {
				r.push({name: null, fn: n});
			}
		},
		Modernizr = function () {};
	(Modernizr.prototype = f),
		(Modernizr = new Modernizr()),
		Modernizr.addTest('customevent', 'CustomEvent' in n && 'function' == typeof n.CustomEvent),
		Modernizr.addTest('promises', function () {
			return (
				'Promise' in n &&
				'resolve' in n.Promise &&
				'reject' in n.Promise &&
				'all' in n.Promise &&
				'race' in n.Promise &&
				(function () {
					var e;
					return (
						new n.Promise(function (n) {
							e = n;
						}),
						'function' == typeof e
					);
				})()
			);
		});
	var l = e.documentElement,
		c = 'svg' === l.nodeName.toLowerCase();
	i(), t(a), delete f.addTest, delete f.addAsyncTest;
	for (var u = 0; u < Modernizr._q.length; u++) Modernizr._q[u]();
	n.Modernizr = Modernizr;
})(window, document);
